import { FC, useEffect, useState } from "react";
import { Card, Modal, Spin, Steps } from "antd";
import Info from "../../components/service/add/Info";
import PriceOption from "../../components/service/add/PriceOption";
import TeamMember from "../../components/service/add/TeamMember";
import "../../styles/_switch.scss";
import "../../styles/_steps.scss";
import { useSelector } from "react-redux";

import { useIntl } from "react-intl";
import { useQuery } from "@tanstack/react-query";
import { getServiceDetails } from "../../network/service";
interface AddServiceFormProps {
  visible: boolean;
  onClose: () => void;
  editServiceData?: any;
}

const AddServiceForm: FC<AddServiceFormProps> = ({
  visible,
  onClose,
  editServiceData,
}) => {
  const [current, setCurrent] = useState(0);

  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );

  const {
    data: serviceDetails,
    isLoading,
    refetch,
  } = useQuery(
    ["service", editServiceData?.id],
    () => getServiceDetails(locationId, editServiceData?.id),
    {
      enabled: !!editServiceData?.id,
      select: (data) => data?.data,
    }
  );
  const [serviceInfo, setServiceInfo] = useState({} as any);
  const onNextStep = () => {
    setCurrent(current + 1);
  };

  const onCancel = () => {
    refetch();
    setServiceInfo({});
    onClose();
  };

  useEffect(() => {
    if (serviceDetails?.id) {
      setServiceInfo(serviceDetails);
    }
  }, [serviceDetails?.id]);
  const intl = useIntl();

  const steps = [
    {
      sec_title: intl.formatMessage({ id: "step1_section_title" }),
      title: intl.formatMessage({ id: "step1_title" }),

      component:
        editServiceData && !serviceInfo?.id ? (
          <div className="flex justify-center items-center">
            <Spin size="large" />
          </div>
        ) : (
          <Info
            onClose={onCancel}
            onNextStep={onNextStep}
            serviceInfo={serviceInfo}
            setServiceInfo={setServiceInfo}
          />
        ),
    },
    {
      sec_title: intl.formatMessage({ id: "step2_section_title" }),
      title: intl.formatMessage({ id: "step2_title" }),
      component:
        isLoading && editServiceData?.id ? (
          <div className="flex justify-center items-center">
            <Spin size="large" />
          </div>
        ) : (
          <TeamMember
            serviceInfo={serviceInfo}
            setServiceInfo={setServiceInfo}
            onClose={onCancel}
            onNextStep={onNextStep}
          />
        ),
    },
    {
      sec_title: intl.formatMessage({ id: "step3_section_title" }),
      title: intl.formatMessage({ id: "step3_title" }),
      component:
        isLoading && editServiceData?.id ? (
          <div className="flex justify-center items-center">
            <Spin size="large" />
          </div>
        ) : (
          <PriceOption
            onClose={onCancel}
            serviceInfo={serviceInfo}
            setServiceInfo={setServiceInfo}
          />
        ),
    },
  ];

  const onChange = (value: number) => {
    console.log("onChange:", value);
    if (current < value) {
      return;
    }
    setCurrent(value);
  };
  const currentStepComponent = steps[current].component;
  return (
    <Modal
      centered
      open={visible}
      onCancel={onCancel}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      destroyOnClose
      footer={[]}
      width={1200}
      className="custom-modal" // Add a custom class here
    >
      <div className="mt-9 flex gap-4 flex  justify-center content-center">
        <div className="normalSteps min-w-[200px]">
          <Steps
            direction="vertical"
            current={current}
            items={steps}
            onChange={onChange}
            responsive={false}
            className="vertical-steps"
            style={{ height: "130%" }}
            size="small"
          />
        </div>
        <div>
          <Card className="h-full !min-w-[773px]">
            <div className="text-color-primary text-2xl font-semibold  text-center">
              {editServiceData
                ? intl.formatMessage({ id: "edit_service_edit" })
                : intl.formatMessage({ id: "edit_service_add" })}
            </div>
            {steps?.map((step, index) =>
              current === index ? (
                <div
                  key={index}
                  className="my-4 text-color-gray text-base font-normal  text-center"
                >
                  {step.sec_title}
                </div>
              ) : null
            )}

            {currentStepComponent}
          </Card>
        </div>
      </div>
    </Modal>
  );
};

export default AddServiceForm;
